import script from "./list-chuc-danh.vue?vue&type=script&setup=true&lang=js"
export * from "./list-chuc-danh.vue?vue&type=script&setup=true&lang=js"

import "./list-chuc-danh.vue?vue&type=style&index=0&id=20f1f9e3&lang=scss&scoped=true"

import exportComponent from "D:\\vsts-agent\\_work\\42\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20f1f9e3"]])

export default __exports__